import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollToTop = ({ left = 0, top = 0, behavior =  null} = {}) => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (behavior) {
            window.scrollTo({top: top, left: left, behavior: behavior})
        }
        else {
            window.scrollTo({top: top, left: left});
        }
    }, [pathname, left, top, behavior]);

    useEffect(() => {
        if (hash?.includes("#")) {
            document.querySelector(hash)?.scrollIntoView();
        }
    }, [hash]);

    const scrollTo = (top, left, behavior = null) => {
        if (behavior) {
            window.scrollTo({top: top, left: left, behavior: behavior})
        }
        else {
            window.scrollTo({top: top, left: left});
        }
    }

    return { scrollTo };
}